import {
  Button,
  Drawer,
  Icon,
  List,
  ListHeading,
  ListSubheading,
  Tooltip,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { getGroupedDashboardByType } from 'client/store/entities/analytics/selectors';
import { OwnerType } from 'common/enums/owner-enums';
import { IDashboard } from 'common/interfaces/analytics';
import { startCase } from 'es-toolkit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';

type TDashboardDrawerProps = {
  selectedDashboardId: string;
  onOpenCreateModal: () => void;
  onSelectDashboard: (dashboardid: string) => void;
  onEditDashboard: (item: IDashboard) => void;
  onDeleteDashboard: (item: IDashboard) => void;
};

export const DashboardDrawer = ({
  selectedDashboardId,
  onOpenCreateModal,
  onSelectDashboard,
  onDeleteDashboard,
  onEditDashboard,
}: TDashboardDrawerProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(true);
  const [expandedState, setExpandedState] = useState<{ [key: string]: boolean }>({});

  const groupedDashboard = useSelector(getGroupedDashboardByType);

  const headingFunctor = (key: string, items: IDashboard[]) => ({
    name: startCase(key),
    metaCount: items.length,
    expanded: !!expandedState[key],
    onClick: () => setExpandedState({
      ...expandedState,
      [key]: !expandedState[key],
    }),
  });

  const itemsFunctor = (items: IDashboard[]) => ({
    items: items.map((item) => ({
      ...item,
      id: item.dashboardid,
      active: item.dashboardid === selectedDashboardId,
      onClick: () => {
        onSelectDashboard(item.dashboardid!);
      },
      actions: [
        {
          icon: 'edit',
          onClick: () => {
            onEditDashboard(item);
          },
        },
        {
          icon: 'delete',
          onClick: () => {
            onDeleteDashboard(item);
          },
        },
      ],
    })),
  });

  return (
    <Drawer
      button={<Button round onClick={() => setOpen(!open)} icon={open ? <FaArrowLeft /> : <FaArrowRight />} />}
      width="300px"
      closedWidth="var(--size-sidebar)"
      border
      open={open}
    >
      <ListHeading
        name={t(translations.analytic_dashboardSelect)}
        actions={[
          {
            label: 'Add',
            icon: <Tooltip text={t(translations.add)}><Icon icon="add" /></Tooltip>,
            primary: true,
            onClick: onOpenCreateModal,
          },
        ]}
      />
      {Object.keys(groupedDashboard).map(key => {
        return (
          <>
            <ListSubheading item={headingFunctor(key, groupedDashboard[key as keyof typeof OwnerType])} />
            {expandedState[key] && <List noHeader list={itemsFunctor(groupedDashboard[key as keyof typeof OwnerType])} />}
          </>
        );
      })}
    </Drawer>
  );
};
